import { Formatter } from '../formatter';

export const ibanFormatter: Formatter = {
    format(ibanValue: string): string {
        return ibanValue.toUpperCase().replace(/\s/g, '');
    },

    formatDisplay(ibanValue: string): string {
        const value = this.format(ibanValue).match(/[A-Z]{1,4}|[0-9]{1,4}/g);
        const displayValue = value?.join(' ').replace(/^([A-Z]+)(\s)/, '$1');
        return displayValue || ibanValue;
    }
};
